import * as React from 'react'

export default () => (
  <svg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='m5 5 14.142 14.142M5 19 19.142 4.858' stroke='currentColor' strokeLinecap='round' />
  </svg>
)
